import useVehiclePageData from '../use-vehicle-page-data'
import { now } from '../../../utils/date-service'
import { MAX_AGE_OF_VEHICLE_FOR_LEASE } from '../../../constants'

const minSupportedLeaseYear = now().getFullYear() - MAX_AGE_OF_VEHICLE_FOR_LEASE

export default function Deals() {
  const { paymentInfo, vehicleData } = useVehiclePageData()
  return (
    <div
      className={`deals flex alignCenter ${
        vehicleData?.year >= minSupportedLeaseYear ? 'justifyBetween' : 'justifyCenter'
      }`}
    >
      <div className='finance'>
        <div className='value'>
          {paymentInfo?.loanMonthlyPayment <= 0
            ? 'N/A'
            : paymentInfo?.loanMonthlyPayment.toLocaleString('en-US', {
                style: 'currency',
                currency: 'USD',
                maxFractionDigits: 0,
                minFractionDigits: 0,
              }) ?? 'N/A'}
          /mo
        </div>
        <div className='label'>
          Finance {paymentInfo?.term}mo @ {paymentInfo?.interestRate}%
        </div>
      </div>

      {vehicleData?.year >= minSupportedLeaseYear && (
        <div className='lease'>
          <div className='value'>
            {paymentInfo?.leaseMonthlyPayment > 0 &&
            paymentInfo?.leaseMonthlyPayment != paymentInfo?.loanMonthlyPayment
              ? `${
                  paymentInfo?.leaseMonthlyPayment.toLocaleString('en-US', {
                    style: 'currency',
                    currency: 'USD',
                    maxFractionDigits: 0,
                    minFractionDigits: 0,
                  }) ?? 'N/A'
                }/mo`
              : 'N/A'}
          </div>
          <div className='label'>
            Lease {paymentInfo?.term}mo @ {paymentInfo?.interestRate}%
            <p>Based on {paymentInfo?.annualMileage} mile annual usage</p>
          </div>
        </div>
      )}
      <style jsx>{`
        .deals {
          padding: 0.5rem 0;
          border-radius: 1rem;
          background: #1a1e21;
        }

        .lease,
        .finance {
          width: 47%;
          text-align: center;
        }

        .value {
          color: var(--primary-color);
          font-size: 1.8rem;
          font-weight: 700;
        }

        .label {
          color: var(--secondary-text-color);
          font-size: 1.2rem;
        }

        @media (max-width: 1024px) {
          .deals {
            margin: 1.1rem 0 0;
          }
        }
      `}</style>
    </div>
  )
}
